import { render, staticRenderFns } from "./CustomAttributes.vue?vue&type=template&id=5624f67e&scoped=true&"
import script from "./CustomAttributes.vue?vue&type=script&lang=js&"
export * from "./CustomAttributes.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttributes.vue?vue&type=style&index=0&id=5624f67e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5624f67e",
  null
  
)

export default component.exports